// Multipliers to get to KBTU
export default {
  energy: 3.41214,
  gas: 1000,
  chilled_water: 12,
  steam: 1.04,
  simulation: 3.41214
};
